export default __webpack_public_path__ + "static/media/carolina.d51b0bb1.png";